import { State } from 'app/redux';

export const getPricingRulesAll = (state: State) =>
  state.pricingRules.pricingRules;

export const getPricingRules = (state: State) =>
  getPricingRulesAll(state).items;

export const getSearches = (state: State) => state.pricingRules.searches;
